<template>
  <div>
    <div class="random-hear-container">
      <div class="red" style="font-size: 26px">
        “说出你我的故事，听见小康的声音。”
      </div>
      <div>
        2019年12月23日起，《听·见小康》栏目推出，每周不少于一期，至今已连续刊载
        <span class="red">62期</span> 。
      </div>
      <div>2020年，“听·见小康”大型融媒体行动启动，</div>
      <div>
        至12月30日，已采集百姓“小康心愿” <span class="red">5644条</span>；
      </div>
      <div>已拍摄百姓“小康笑脸” <span class="red">6350张</span>；</div>
      <div>已收集百姓签名 <span class="red">10500个</span>。</div>
      <div class="divider"></div>
      <div>“听·见小康”的讲述还在继续……</div>
    </div>

    <div>
      <img
        src="https://jcdn.xhby.net/project/xiaokang/assets/randomHear/back.png"
        alt=""
        class="icon back"
        @click="back"
      />
      <img
        src="https://jcdn.xhby.net/project/xiaokang/assets/randomHear/next.png"
        alt=""
        class="icon next"
        @click="next"
      />
      <div>
        <img
          :src="
            item.isCasting
              ? 'https://jcdn.xhby.net/project/xiaokang/assets/randomHear/04-stop.png'
              : 'https://jcdn.xhby.net/project/xiaokang/assets/randomHear/huatong.png'
          "
          alt=""
          class="icon blinIcon huatong"
          v-for="(item, i) in icons"
          :key="i"
          :style="{ left: `${item.x}vw`, top: `${item.y}vh` }"
          @click="playAndPause(i)"
        />
      </div>

      <img
        src="../new-assets/flt.png"
        alt=""
        class="icon blinIcon video-icon"
        @click="showVideoDialog"
      />

      <div class="dialog-container" v-if="isShowDetail">
        <div class="dialog-inner">
          <img
            src="https://jcdn.xhby.net/project/xiaokang/assets/detail/close.png"
            alt=""
            class="close-img"
            @click="isShowDetail = false"
          />
          <div class="dialog-inner-2">
            <video
              src="https://jcdn.xhby.net/project/xiaokang/video/end.mp4"
              controls="controls"
              poster="https://jcdn.xhby.net/project/xiaokang/assets/welcome/poster.png"
              autoplay
            ></video>
          </div>
        </div>
      </div>

      <audio src="" ref="audio"></audio>
    </div>
  </div>
</template>

<script >
export default {
  props: {
    next: Function,
    back: Function,
  },
  data() {
    return {
      icons: [
        {
          x: 10,
          y: 8,
          isCasting: false,
        },
        {
          x: 2,
          y: 40,
          isCasting: false,
        },
        {
          x: 60,
          y: 10,
          isCasting: false,
        },
        {
          x: 70,
          y: 52,
          isCasting: false,
        },
        {
          x: 50,
          y: 70,
          isCasting: false,
        },
      ],

      audioList: [
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/random/1.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/random/2.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/random/3.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/random/4.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/random/5.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/random/6.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/random/7.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/random/8.mp3",
      ],

      isShowDetail: false,
      isOnePlaying: false,
    };
  },
  mounted() {
    this.shuffle(this.audioList);
  },
  methods: {
    playAndPause(i) {
      this.icons.forEach((icon, _i) => {
        if (_i === i) return;
        icon.isCasting = false;
      });
      this.isOnePlaying = false;
      this.icons[i].isCasting = !this.icons[i].isCasting;
      if (this.icons[i].isCasting) {
        // 播放
        this.play(this.audioList[i]);
      } else {
        this.stop();
      }
    },

    shuffle(arr) {
      let array = arr;
      let len = array.length;
      for (let i = len - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    },

    play(src) {
      const audioInstance = this.$refs.audio;
      if (src) {
        audioInstance.src = src;
      }
      audioInstance.play();
    },

    stop() {
      const audioInstance = this.$refs.audio;
      audioInstance.pause();
    },

    showVideoDialog() {
      this.icons.forEach((icon) => {
        icon.isCasting = false;
      });
      this.isOnePlaying = false;
      this.stop();
      this.isShowDetail = true;
    },

    playAndPauseOne() {
      this.icons.forEach((icon) => {
        icon.isCasting = false;
      });
      this.isOnePlaying = !this.isOnePlaying;
      if (this.isOnePlaying) {
        const audioInstance = this.$refs.audio;
        audioInstance.src = this.audioList[7];
        audioInstance.play();
      } else {
        this.stop();
      }
    },
  },
};
</script>

<style scoped lang="less">
.random-hear-container {
  width: 100vw;
  height: 100vh;
  background-image: url("https://jcdn.xhby.net/project/xiaokang/assets/randomHear/04bg.jpg");
  background-size: cover;
  background-position: 50% 50%;
  position: relative;
  padding: 0 calc(50vw - 500px);
  font-size: 24px;
  line-height: 44px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;

  .red {
    color: #c3363c;
    font-weight: 600;
  }

  .divider {
    height: 20px;
  }
}

.icon {
  width: 100px;
  position: absolute;
  cursor: pointer;
}

.blinIcon {
  opacity: 0.5;
  animation: bulinbulin 6s infinite;

  &:nth-child(1) {
    animation-delay: 0s;
  }

  &:nth-child(2) {
    animation-delay: 0.5s;
  }

  &:nth-child(3) {
    animation-delay: 1s;
  }

  &:nth-child(4) {
    animation-delay: 1.5s;
  }

  &:nth-child(5) {
    animation-delay: 2s;
  }

  &:nth-child(6) {
    animation-delay: 2.5s;
  }
}

@keyframes bulinbulin {
  from {
    opacity: 0.5;
  }

  50% {
    opacity: 1;
    transform: translateY(-20px);
  }

  to {
    opacity: 0.5;
  }
}

.back {
  left: calc(50vw - 600px);
  bottom: 80px;
}

.next {
  right: calc(50vw - 600px);
  bottom: 80px;
}

.video-icon {
  width: 100px;
  right: 120px;
  top: 50vh;
}

.dialog-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;

  .dialog-inner {
    width: 75vw;
    height: 75vh;
    border: 10px solid #ffeccb;
    background: white;
    position: relative;

    .close-img {
      position: absolute;
      width: 60px;
      top: -30px;
      right: -30px;
      cursor: pointer;
    }

    .dialog-inner-2 {
      width: 100%;
      height: 100%;
      border: 1px dashed #c56f6f;
      display: flex;
      align-items: center;
      justify-content: center;

      video {
        width: 90%;
        height: 90%;
        object-fit: scale-down;
        background: black;
      }
    }
  }
}
</style>

